/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Meeting_People_CountInputs */

const th_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} คน`)
};

const en_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} people`)
};

const ja_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人`)
};

const zh_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人`)
};

const es_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} personas`)
};

const pt_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pessoas`)
};

const id_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} orang`)
};

const fr_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} personnes`)
};

const tl_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tao`)
};

const vi_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} người`)
};

const ko_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}명`)
};

const de_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Personen`)
};

const ru_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Участников: ${i?.count}`)
};

const tr_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kişi`)
};

const it_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} persone`)
};

const pl_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Osób: ${i?.count}`)
};

const uk_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Учасників: ${i?.count}`)
};

const hi_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} लोग`)
};

const ar_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} أشخاص`)
};

const ms_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} orang`)
};

const bn_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} জন`)
};

const zh_tw2_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人`)
};

const zh_hk2_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人`)
};

const ur_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} افراد`)
};

const fa_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} نفر`)
};

const sw_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Watu ${i?.count}`)
};

const nl_meeting_people_count = /** @type {(inputs: Meeting_People_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} personen`)
};

/**
* | output |
* | --- |
* | "{count} people" |
*
* @param {Meeting_People_CountInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_people_count = /** @type {((inputs: Meeting_People_CountInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_People_CountInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_people_count(inputs)
	if (locale === "ja") return ja_meeting_people_count(inputs)
	if (locale === "zh") return zh_meeting_people_count(inputs)
	if (locale === "es") return es_meeting_people_count(inputs)
	if (locale === "pt") return pt_meeting_people_count(inputs)
	if (locale === "id") return id_meeting_people_count(inputs)
	if (locale === "fr") return fr_meeting_people_count(inputs)
	if (locale === "tl") return tl_meeting_people_count(inputs)
	if (locale === "vi") return vi_meeting_people_count(inputs)
	if (locale === "ko") return ko_meeting_people_count(inputs)
	if (locale === "de") return de_meeting_people_count(inputs)
	if (locale === "ru") return ru_meeting_people_count(inputs)
	if (locale === "tr") return tr_meeting_people_count(inputs)
	if (locale === "it") return it_meeting_people_count(inputs)
	if (locale === "pl") return pl_meeting_people_count(inputs)
	if (locale === "uk") return uk_meeting_people_count(inputs)
	if (locale === "hi") return hi_meeting_people_count(inputs)
	if (locale === "ar") return ar_meeting_people_count(inputs)
	if (locale === "ms") return ms_meeting_people_count(inputs)
	if (locale === "bn") return bn_meeting_people_count(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_people_count(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_people_count(inputs)
	if (locale === "ur") return ur_meeting_people_count(inputs)
	if (locale === "fa") return fa_meeting_people_count(inputs)
	if (locale === "sw") return sw_meeting_people_count(inputs)
	if (locale === "nl") return nl_meeting_people_count(inputs)
	return en_meeting_people_count(inputs)
});